<div #navContainer *ngIf="menuItems.length > 1">

  <nav #nav class="bg-white">

    <div class="container">

        <div class="btn btn-rounded-circle btn-white next" (click)="scrollOverflow()" #showMore>
            <svg width="12px" height="22px" viewBox="0 0 12 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                 <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.298153832">
                    <g transform="translate(-620.000000, -2795.000000)" stroke="#323C47" stroke-width="1.5">
                    <polyline points="621 2816 631 2806 621 2796"></polyline>
                    </g>
                </g>
            </svg>
        </div>


      <div class="row align-items-center">

        <div class="col offset-lg-1 nav-overflow-container">

          <ul class="nav nav-tabs nav-overflow header-tabs" #overflowList (scroll)="getScrollPosition()">
            <li class="nav-item" *ngFor="let item of menuItems; let i=index">
              <a id="navitem-{{item.container}}" (click)="itemClick(item.container, i)" class="nav-link" [class.active]="item.active" [class.anim-left]="item.animDirection=='left'" [class.anim-right]="item.animDirection=='right'">
                {{item.label}}
              </a>
            </li>
          </ul>

        </div>

      </div>

    </div>

  </nav>

</div>

